import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=df5a63aa&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5a63aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df5a63aa')) {
      api.createRecord('df5a63aa', component.options)
    } else {
      api.reload('df5a63aa', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=df5a63aa&scoped=true&", function () {
      api.rerender('df5a63aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OI4XHVSXjHV2/JS/comp/Voucher-Unit.vue"
export default component.exports